export default function Tabs() {
    const tabBlocks = document.querySelectorAll(".totaldigital-tabs");

    tabBlocks.forEach(function (tabBlock, i) {
        const tabLabels = tabBlock.querySelectorAll(".tab-label");
        const tabPanels = tabBlock.querySelectorAll(".tab-panel");

        const toggleEvent = function (e) {
            if (e.type === "click") {
                return true;
            } else if (e.type === "keypress") {
                const code = e.charCode || e.keyCode;
                if (code === 32 || code === 13) {
                    return true;
                }
            } else {
                return false;
            }
        };

        const toggleTabClasses = function (label, i) {
            const activeTab = tabBlock.querySelector(".tab-label.active");
            const activePanel = tabBlock.querySelector(".tab-panel.active");

            activeTab.classList.remove("active");
            activeTab.setAttribute("tabindex", -1);
            activeTab.setAttribute("aria-selected", false);

            label.classList.add("active");
            label.setAttribute("tabindex", 0);
            label.setAttribute("aria-selected", true);

            activePanel.classList.remove("active");
            activePanel.setAttribute("tabindex", -1);
            activePanel.setAttribute("aria-selected", false);
            activePanel.setAttribute("hidden", true);

            tabPanels[i].classList.add("active");
            tabPanels[i].setAttribute("tabindex", 0);
            tabPanels[i].setAttribute("aria-selected", true);
            tabPanels[i].removeAttribute("hidden");
        };

        const getLinks = (panel) => {
            const tabLinks = panel.querySelectorAll("a");
            if (tabLinks && tabLinks.length) {
                return [...tabLinks].filter(function (el) {
                    const h = el.getAttribute("href");
                    return h && h.includes("tab_");
                });
            }
            return [];
        };

        tabLabels.forEach(function (label, i) {
            if (label.classList.contains("active")) {
                if (tabPanels[i]) {
                    tabPanels[i].classList.add("active");
                } else {
                    tabPanels[0].classList.add("active");
                    tabLabels[0].classList.add("active");
                }
            }

            label.addEventListener("click", function (e) {
                if (toggleEvent(e) === true) {
                    toggleTabClasses(label, i);
                }
            });
            label.addEventListener("keypress", function (e) {
                if (toggleEvent(e) === true) {
                    toggleTabClasses(label, i);
                }
            });

            if (tabPanels[i]) {
                const links = getLinks(tabPanels[i]);
                links.forEach(function (link, i) {
                    link.addEventListener("click", function (e) {
                        if (toggleEvent(e) === true) {
                            e.preventDefault();
                            const h = e.target.getAttribute("href");
                            const hs = h ? h.split("_") : false;
                            let hi = hs ? hs[1] : false;
                            if (hi) {
                                hi = parseInt(hi);
                                toggleTabClasses(tabLabels[hi - 1], hi - 1);
                            }
                        }
                    });
                });
            }
        });
    });
}
